import { isAnyOf } from "@reduxjs/toolkit";

import { closeBillingThunk, deleteBillingThunk, submitBillingThunk } from "../../reducers/billingReducer";
import { startAppListening } from "./listenerMiddleware";
import { resetBillingList } from "./utils/resetBillingsList";

export const billingsListener = (): void => {
  startAppListening({
    matcher: isAnyOf(deleteBillingThunk.fulfilled, submitBillingThunk.fulfilled, closeBillingThunk.fulfilled),
    effect: async (_, { dispatch }) => {
      resetBillingList(dispatch);
    },
  });
};
